import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { MarketMatrixModel } from './MarketMatrix.model';
import { ButtonComponent } from '../../../button/button.component';
import { FormComponent } from '../../../form/form.component';
import { ServiceStock } from '../../../service-stock.service';
import { ProductComponent } from '../../../gotx/components/Product/Product.component';
import { GotxMarketDepthComponent } from '../../../gotx/components/gotx-market-depth/gotx-market-depth.component';
import { StockComponent } from '../Stock/Stock.component';
import { MarketWatchService } from 'src/app/market-watch.service';

const customCss: string = '';

@Component({
  selector: 'app-MarketMatrix',
  templateUrl: './MarketMatrix.component.html'
})
export class MarketMatrixComponent extends FormComponent implements OnInit, AfterViewInit {
  @ViewChild('FieldId_7', { static: false }) FieldId_7: ElementRef;
  @ViewChild('cstmProduct', { static: false }) cstmProduct: ProductComponent;
  @ViewChild('cmbStock', { static: false }) cmbStock: StockComponent;
  @ViewChild('btnSubmit', { static: false }) btnSubmit: ButtonComponent;
  @ViewChild('MarketDepth', { static: false }) MarketDepth: GotxMarketDepthComponent;
  skeletonContentLoaded = false;
  productSelected = this.services.dataStore.getproductMasterData();

  async revalidate(): Promise<number> {
    var totalErrors = 0;
    super.beforeRevalidate();
    await Promise.all([
      this.cstmProduct.revalidate(),
    ]).then((errorCounts) => {
      errorCounts.forEach((errorCount) => {
        totalErrors += errorCount;
      });
    });
    this.errors = totalErrors;
    super.afterRevalidate();
    return totalErrors;
  }
  constructor(services: ServiceStock, private marketService: MarketWatchService) {
    super(services);
    this.value = new MarketMatrixModel();
    this.componentCode = 'MarketMatrix';
    this.displayBorder = false;
  }
  setReadOnly(readOnly) {
    super.setBasicFieldsReadOnly(readOnly);
    this.cstmProduct.setReadOnly(readOnly);
  }
  async onFormLoad() {
    this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));
    this.setDependencies();
    this.reloadStock();
    this.cmbStock.gotxInput.focus();

  }
  setInputs(param: any) {
    let params = this.services.http.mapToJson(param);
    if (params['mode']) {
      this.mode = params['mode'];
    }
  }
  async submitForm(path, apiCode, serviceCode) {
    this.submitData['formName'] = 'MarketMatrix';
    await super.submit(path, apiCode, serviceCode);
  }
  getFieldInfo() {
    this.amountComponent.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    this.comboFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    // this.fileUploadFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    this.additionalInfo['cstmProduct_desc'] = this.cstmProduct.getFieldInfo();
    return this.additionalInfo;
  }
  getFieldValue() {
    this.value.cstmProduct = this.cstmProduct.getFieldValue();
    return this.value;
  }
  setValue(inputValue, inputDesc = undefined) {
    this.setBasicFieldsValue(inputValue, inputDesc);
    this.cstmProduct.setValue(inputValue['cstmProduct'], inputDesc['cstmProduct_desc']);
    this.value = new MarketMatrixModel();
    this.value.setValue(inputValue);
    this.setDependencies();
    this.passNewValue(this.value);
  }
  setProductField(value: string): void {
    this.productSelected = value;
  }

  ngOnInit() {
    if (this.formCode == undefined) { this.formCode = 'MarketMatrix'; }
    if (this.formOnLoadError) { return; }
    setTimeout(() => {
      this.skeletonContentLoaded = true;
    }, 1000);
    var styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    styleElement.innerHTML = customCss;
    styleElement.id = 'MarketMatrix_customCss';
    document.getElementsByTagName('head')[0].appendChild(styleElement);
    this.setProductField(this.productSelected);
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    var styleElement = document.getElementById('MarketMatrix_customCss');
    styleElement.parentNode.removeChild(styleElement);
    if (this.subbedStock != null)
      this.marketService.unSubscribeMarket([this.subbedStock]); // unsubscribe
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.subsBFldsValueUpdates();
      this.value.cstmProduct = this.cstmProduct.getFieldValue();
      this.cstmProduct.valueChangeUpdates().subscribe((value) => { this.value.cstmProduct = value; });
      this.onFormLoad();
      this.checkForHTabOverFlow();
    });
  }
  clearError() {
    super.clearBasicFieldsError();
    super.clearHTabErrors();
    super.clearVTabErrors();
    this.cstmProduct.clearError();
    this.errors = 0;
    this.errorMessage = [];
  }
  onReset() {
    super.resetBasicFields();
    this.cstmProduct.onReset();
    this.clearHTabErrors();
    this.clearVTabErrors();
    this.errors = 0;
    this.errorMessage = [];
    this.additionalInfo = undefined;
    this.dependencyMap.clear();
    this.value = new MarketMatrixModel();
    this.passNewValue(this.value);
    this.setReadOnly(false);
    this.onFormLoad();
  }
  async cstmProduct_productSelected() {
    this.reloadStock();
  }
  async cmbStock_stockSelected() {
    if (this.cmbStock.gotxInput.val() != null && this.cmbStock.gotxInput.val().value != null) {
      this.exchSymbol = this.cmbStock.gotxInput.val().value;
    }

  }
  reloadStock() {
    if (this.cstmProduct != undefined) {
      this.cmbStock.gotxInput.val("");
      let exch = this.services.dataStore.getData("exchangeID");
      let pdct = this.cstmProduct.cmbProduct.getFieldValue();
      if (typeof pdct == 'object' ){
        pdct = pdct.text
    }
      let board = "AL";
      this.cmbStock.source = this.services.dataStore.getcmbStockInput(this.cmbStock.searchMode, exch, pdct, board);
    }
  }
  async btnSubmit_click(event) {
    var errorCount: number = await this.revalidate();
    if (errorCount == 0) {

      this.exchange = this.services.dataStore.getData("exchangeID");
      this.product = this.cstmProduct.cmbProduct.getFieldValue();
      if (typeof this.cmbStock.gotxInput.val() === 'object') {
        this.symbol = this.cmbStock.gotxInput.val().label;
       // this.exchSymbol = this.cmbStock.gotxInput.val().value;
      }
      else {
        this.symbol = this.cmbStock.gotxInput.val();
       // this.exchSymbol = this.cmbStock.gotxInput.val();
      }
      //this.symbol = this.cmbStock.gotxInput.val().label;
      //this.exchSymbol = this.cmbStock.gotxInput.val().value;

      this.marketService.getStockQuote(this.exchange, this.product, this.symbol);

      let alreadySub = this.services.dataStore.subbedStocks.filter(el => el.Exch == this.exchange && el.Symbol == this.exchSymbol
        && el.Product == this.product);

      //console.log("alreadySub", alreadySub);

      if (this.subbedStock != null) {
        this.marketService.unSubscribeMarket([this.subbedStock]); // unsubscribe
      }

      if ((alreadySub == null || alreadySub.length <= 0) && this.exchSymbol != null) {
        this.subbedStock = { "Symbol": this.exchSymbol, "Exch": this.exchange, "Product": this.product };
        this.marketService.marketWatchStockSubs([this.subbedStock], 'DEPTH.IWS.DATA.REQ');//DEPTH.DATA.REQ // MW.IWS.STOCKS.SUBS
      } else {
        this.subbedStock = null;
      }
    }
  }
  transalte(text) {
    return this.services.translate.instant(text);
  }
  fieldDependencies = {
  }
  /* Write Custom Scripts Here */

  symbol: string = '';
  symbolName = "NA";
  exchSymbol: any[] = [];
  exchange: any[] = [];
  product: any[] = [];
  subbedStock = null;
}